import {BlockPosition} from "./BlockPosition.js";

export class InstrumentAnnotationBlock {
    constructor(jsonStructure) {
        this.block_position = new BlockPosition(jsonStructure.block_position);
        const hasOwn = key => Object.prototype.hasOwnProperty.call(jsonStructure, key);

        // Loaded blocks retain the exact presence of optional persisted fields.
        [
            'instrument_function',
            'texture',
            'voicing',
            'rhythm_density',
            'rhythm_description',
            'secondary_melody_categorization',
            'articulation_techniques',
            'effects_of_articulation',
            'melody_description',
            'technique',
            'dynamics'
        ].forEach(key => {
            if (hasOwn(key)) this[key] = jsonStructure[key];
        });
        if (hasOwn("String Articulation Techniques")) {
            this.string_articulation_techniques = jsonStructure["String Articulation Techniques"];
        } else if (hasOwn('string_articulation_techniques')) {
            this.string_articulation_techniques = jsonStructure.string_articulation_techniques;
        }
        
        // Add any additional fields dynamically
        Object.entries(jsonStructure).forEach(([key, value]) => {
            if (!['block_position', 'instrument_function', 'texture', 'voicing', 
                  'rhythm_density', 'rhythm_description', 'secondary_melody_categorization', 
                  'string_articulation_techniques', 'articulation_techniques', 'effects_of_articulation', 'melody_description',
                  'technique', 'dynamics'].includes(key) && value !== undefined) {
                this[key] = value;
            }
        });
    }
}
